import { render, staticRenderFns } from "./TenderClassification.vue?vue&type=template&id=be84041c"
import script from "./TenderClassification.vue?vue&type=script&lang=js"
export * from "./TenderClassification.vue?vue&type=script&lang=js"
import style0 from "./TenderClassification.vue?vue&type=style&index=0&id=be84041c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports